import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Machines from "@/pages/Machines";
import Schedules from "@/pages/Schedules";
import Spareparts from "@/pages/Spareparts";
import Technicians from "@/pages/Technicians";
import Repairs from "@/pages/Repairs";
import Reports from "@/pages/Reports";
import SparepartOrders from "@/pages/SparepartOrders";
import PreventiveHistory from "@/pages/PreventiveHistory";
import Users from "@/pages/Users";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/machines" element={<Machines />} />
              <Route path="/schedules" element={<Schedules />} />
              <Route path="/spareparts" element={<Spareparts />} />
              <Route path="/technicians" element={<Technicians />} />
              <Route path="/repairs" element={<Repairs />} />
              <Route path="/sparepart-orders" element={<SparepartOrders />} />
              <Route path="/preventive-history" element={<PreventiveHistory />} />
              <Route path="/reports" element={<Reports />} />
              <Route
                path="/users"
                element={
                  <ProtectedRoute adminOnly>
                    <Users />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
